import { useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import claraChat from "@/assets/clara-chat.jpg";

const FloatingChat = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleWhatsAppClick = () => {
    window.open('https://wa.me/61423038977', '_blank');
  };

  return (
    <div className="fixed bottom-4 right-4 sm:bottom-6 sm:right-6 z-50">
      {/* Expanded state */}
      {isExpanded && (
        <div 
          className="bg-white rounded-2xl shadow-2xl p-3 sm:p-4 mb-3 sm:mb-4 flex items-center gap-3 sm:gap-4 max-w-[calc(100vw-2rem)]" 
          style={{ 
            animation: 'slideInFromRight 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)',
            transformOrigin: 'right'
          }}
        >
          <img 
            src={claraChat} 
            alt="Clara Camille" 
            width={64}
            height={64}
            className="w-12 h-12 sm:w-16 sm:h-16 rounded-full object-cover border-2 border-primary/20 flex-shrink-0"
          />
          <div className="flex flex-col gap-2">
            <p className="font-sans text-sm font-medium text-foreground whitespace-nowrap">
              Vamos conversar?
            </p>
            <Button
              size="sm"
              variant="gradient"
              className="rounded-full text-xs sm:text-sm"
              style={{ background: 'var(--gradient-green)' }}
              onClick={handleWhatsAppClick}
            >
              <MessageCircle className="mr-1 sm:mr-2 h-4 w-4" />
              Ir para o WhatsApp
            </Button>
          </div>
          <button
            onClick={() => setIsExpanded(false)}
            className="text-muted-foreground hover:text-foreground transition-colors flex-shrink-0"
            aria-label="Fechar"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
      )}

      {/* Collapsed state */}
      {!isExpanded && (
        <button
          onClick={() => setIsExpanded(true)}
          className="group relative"
          aria-label="Abrir chat"
        >
          <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full overflow-hidden border-4 border-white shadow-lg hover:shadow-xl transition-all hover:scale-110 duration-300">
            <img 
              src={claraChat} 
              alt="Clara Camille" 
              width={80}
              height={80}
              className="w-full h-full object-cover"
            />
          </div>
          <div 
            className="absolute inset-0 rounded-full bg-primary/10 animate-ping" 
            style={{ animationDuration: '3s' }}
          />
        </button>
      )}
    </div>
  );
};

export default FloatingChat;
